import * as kendoThemeChooser from "../KednoThemeChooser";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function drawStackedAndGroupedColumn(userDashboardChartLine, h, w, widget, chartArea) {
    widget.kendoChart({
        theme: kendoThemeChooser.currentTheme(),
        legend: {
            position: "bottom"
        },
        series: userDashboardChartLine.stackAndGroupedColData.data,
        seriesDefaults: {
            type: "column"
        },
        chartArea: chartArea,
        tooltip: {
            visible: true,
            template: "#= series.name # <br>  #= value #"
        },
        categoryAxis: {
            categories: userDashboardChartLine.stackAndGroupedColData.categories
        },

    });
    return widget;
}